export default "__VITE_ASSET__QzeHohj1__"